"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = exports.Label = exports.Root = void 0;
const classnames_1 = __importDefault(require("classnames"));
const Root = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (<div className={(0, classnames_1.default)('flex flex-col p-3 bg-brown justify-between flex-initial gap-3 border', className)} {...props}>
			{children}
		</div>);
};
exports.Root = Root;
const Label = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (<span className={(0, classnames_1.default)('font-medium text-lg font-mono', className)} {...props}>
			{children}
		</span>);
};
exports.Label = Label;
const Value = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (<span className={(0, classnames_1.default)('font-bold text-3xl font-mono', className)} {...props}>
			{children}
		</span>);
};
exports.Value = Value;
